import React, { useState } from "react";
import { auth, db } from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, getDoc, runTransaction } from "firebase/firestore";

const STATES = ["Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Delhi","Jammu & Kashmir","Ladakh","Puducherry"];

export default function Register({ onRegister, onLogin, onHome}) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    naam: "", username: "", email: "", phone: "",
    password: "", confirmPassword: "",
    state: "", district: "", city: "", area: "", landmark: "",
    agreeTerms: false,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const update = (key, val) => setForm(p => ({ ...p, [key]: val }));

  const validateStep1 = () => {
    if (!form.naam.trim()) return "Poora naam bharein!";
    if (!form.username.trim()) return "Username bharein!";
    if (!/^[a-z0-9_]+$/.test(form.username)) return "Username mein sirf lowercase letters, numbers aur _ allowed hain!";
    if (!form.email.trim()) return "Email bharein!";
    if (!form.phone.trim() || form.phone.length < 10) return "Valid phone number bharein!";
    if (!form.password || form.password.length < 6) return "Password kam se kam 6 characters ka hona chahiye!";
    if (form.password !== form.confirmPassword) return "Password match nahi kar raha!";
    return null;
  };

  const validateStep2 = () => {
    if (!form.state) return "State select karein!";
    if (!form.district.trim()) return "District bharein!";
    if (!form.city.trim()) return "City bharein!";
    if (!form.agreeTerms) return "Terms & Conditions accept karein!";
    return null;
  };

  const handleNext = async () => {
    setError("");
    if (step === 1) {
      const err = validateStep1();
      if (err) { setError(err); return; }
      const snap = await getDoc(doc(db, "usernames", form.username.toLowerCase()));
      if (snap.exists()) { setError("Yeh username pehle se le liya gaya hai!"); return; }
      setStep(2);
    }
  };

  const handleRegister = async () => {
    setError("");
    const err = validateStep2();
    if (err) { setError(err); return; }
    setLoading(true);

    try {
      const cred = await createUserWithEmailAndPassword(auth, form.email.trim(), form.password);
      const uid = cred.user.uid;

      let membershipId = "GBS-0001";
      try {
        await runTransaction(db, async (transaction) => {
          const counterRef = doc(db, "counters", "memberCount");
          const counterSnap = await transaction.get(counterRef);
          let newCount = 1;
          if (counterSnap.exists()) newCount = (counterSnap.data().count || 0) + 1;
          membershipId = `GBS-${String(newCount).padStart(4, "0")}`;
          transaction.set(counterRef, { count: newCount });
        });
      } catch {
        membershipId = `GBS-${uid.slice(0, 8).toUpperCase()}`;
      }

      await setDoc(doc(db, "users", uid), {
        naam: form.naam.trim(),
        username: form.username.toLowerCase(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        state: form.state,
        district: form.district.trim(),
        city: form.city.trim(),
        area: form.area.trim(),
        landmark: form.landmark.trim(),
        role: "member",
        membershipStatus: "pending",
        membershipId: membershipId,
        membershipFee: 300,
        securityDeposit: 700,
        depositRefunded: false,
        adminAccess: false,
        createdAt: new Date().toISOString(),
        lastSeen: Date.now(),
        loginHistory: [{ loginAt: new Date().toISOString(), timestamp: Date.now() }],
      });

      await setDoc(doc(db, "usernames", form.username.toLowerCase()), {
        email: form.email.trim(), uid: uid,
      });

      onRegister();
    } catch (err) {
      if (err.code === "auth/email-already-in-use") setError("Yeh email pehle se registered hai!");
      else if (err.code === "auth/invalid-email") setError("Valid email address bharein!");
      else setError("Registration mein problem aayi. Dobara try karein!");
    }
    setLoading(false);
  };

  return (
    <div style={S.container}>
      <div style={S.card} className="gbs-fade-in">
        <div style={{ ...S.logoCircle, cursor: "pointer" }} onClick={onHome}><Icon name="building" size={24} color="#fff" /></div>
        <h1 style={S.title}>Register Karein</h1>
        <p style={S.subtitle}>Global Bahuudeshiya Sanstha</p>

        <div style={S.stepRow}>
          <div style={{ ...S.stepDot, background: "#0D1B3E" }}>1</div>
          <div style={{ ...S.stepLine, background: step === 2 ? "#0D1B3E" : "#ECECEE" }} />
          <div style={{ ...S.stepDot, background: step === 2 ? "#0D1B3E" : "#ECECEE", color: step === 2 ? "#fff" : "#9CA3AF" }}>2</div>
        </div>

        {step === 1 && (
          <>
            <p style={S.stepLabel}>Personal Info</p>
            <input style={S.input} placeholder="Poora Naam" value={form.naam} onChange={e => update("naam", e.target.value)} />
            <input style={S.input} placeholder="Username (e.g. rahul_123)" value={form.username} onChange={e => update("username", e.target.value.toLowerCase())} />
            <input style={S.input} placeholder="Email" type="email" value={form.email} onChange={e => update("email", e.target.value)} />
            <input style={S.input} placeholder="Phone Number" type="tel" value={form.phone} onChange={e => update("phone", e.target.value)} />
            <div style={S.passRow}>
              <input style={{ ...S.input, marginBottom: 0, flex: 1 }}
                type={showPass ? "text" : "password"}
                placeholder="Password (min 6 chars)"
                value={form.password}
                onChange={e => update("password", e.target.value)} />
              <button onClick={() => setShowPass(p => !p)} style={S.eyeBtn} type="button">
                <Icon name={showPass ? "eye-off" : "eye"} size={17} color="#9CA3AF" />
              </button>
            </div>
            <div style={{ height: 12 }} />
            <input style={S.input} type="password" placeholder="Confirm Password" value={form.confirmPassword} onChange={e => update("confirmPassword", e.target.value)} />
          </>
        )}

        {step === 2 && (
          <>
            <p style={S.stepLabel}>Address Info</p>
            <select style={S.input} value={form.state} onChange={e => update("state", e.target.value)}>
              <option value="">State Select Karein</option>
              {STATES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <input style={S.input} placeholder="District" value={form.district} onChange={e => update("district", e.target.value)} />
            <input style={S.input} placeholder="City" value={form.city} onChange={e => update("city", e.target.value)} />
            <input style={S.input} placeholder="Area / Ward" value={form.area} onChange={e => update("area", e.target.value)} />
            <input style={S.input} placeholder="Landmark (optional)" value={form.landmark} onChange={e => update("landmark", e.target.value)} />

            <div style={S.feeBox}>
              <p style={S.feeTitle}>Membership Fee</p>
              <p style={S.feeText}>Membership Fee: ₹300 (non-refundable)</p>
              <p style={S.feeText}>Security Deposit: ₹700 (refundable)</p>
              <p style={{ ...S.feeText, fontWeight: 700, color: "#0D1B3E" }}>Total: ₹1000/year</p>
            </div>

            <label style={S.termsRow}>
              <input type="checkbox" checked={form.agreeTerms} onChange={e => update("agreeTerms", e.target.checked)} style={{ accentColor: "#0D1B3E", cursor: "pointer", marginTop: 2 }} />
              <span style={S.termsLabel}>
                Main{" "}
                <a href="/privacy" target="_blank" style={{ color: "#0D1B3E" }}>Terms & Conditions</a>
                {" "}aur{" "}
                <a href="/privacy" target="_blank" style={{ color: "#0D1B3E" }}>Privacy Policy</a>
                {" "}se agree karta/karti hoon
              </span>
            </label>
          </>
        )}

        {error && <p style={S.error}>{error}</p>}

        <div style={{ display: "flex", gap: 10 }}>
          {step === 2 && (
            <button style={S.backBtn} onClick={() => { setStep(1); setError(""); }}>Back</button>
          )}
          <button style={{ ...S.button, opacity: loading ? 0.7 : 1 }}
            onClick={step === 1 ? handleNext : handleRegister}
            disabled={loading}>
            {loading ? "Processing..." : step === 1 ? "Next" : "Register Karein"}
          </button>
        </div>

        <p style={S.footerText}>
          Pehle se account hai?{" "}
          <span style={S.footerLink} onClick={onLogin}>Login karein</span>
        </p>
      </div>
    </div>
  );
}

function Icon({ name, size = 18, color = "#0D1B3E" }) {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "building": return <svg {...common}><rect x="4" y="2" width="16" height="20" rx="1" /><path d="M9 22v-4h6v4M9 6h.01M15 6h.01M9 10h.01M15 10h.01M9 14h.01M15 14h.01" /></svg>;
    case "eye": return <svg {...common}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>;
    case "eye-off": return <svg {...common}><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19M14.12 14.12a3 3 0 1 1-4.24-4.24" /><path d="M1 1l22 22" /></svg>;
    default: return null;
  }
}

const S = {
  container: { minHeight: "100vh", background: "linear-gradient(135deg, #0D1B3E, #1A2F5A)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 },
  card: { background: "#fff", borderRadius: 24, padding: "32px 24px", width: "100%", maxWidth: 380, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" },
  logoCircle: { width: 48, height: 48, background: "#0D1B3E", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" },
  title: { fontSize: 17, fontWeight: 700, color: "#0D1B3E", margin: "0 0 2px", textAlign: "center" },
  subtitle: { fontSize: 12, color: "#9CA3AF", marginBottom: 18, textAlign: "center" },
  stepRow: { display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 18 },
  stepDot: { width: 26, height: 26, borderRadius: "50%", color: "#fff", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" },
  stepLine: { flex: 1, height: 2, maxWidth: 50 },
  stepLabel: { fontSize: 11, fontWeight: 700, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 },
  input: { width: "100%", padding: "12px 14px", borderRadius: 12, border: "1px solid #ECECEE", fontSize: 13, marginBottom: 10, boxSizing: "border-box", outline: "none", background: "#FAFAFA" },
  passRow: { display: "flex", alignItems: "center", gap: 8 },
  eyeBtn: { background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex" },
  feeBox: { background: "#F7F7F9", borderRadius: 12, padding: "12px 14px", marginBottom: 12 },
  feeTitle: { margin: "0 0 6px", fontSize: 12, fontWeight: 700, color: "#0D1B3E", textTransform: "uppercase", letterSpacing: 0.5 },
  feeText: { margin: "2px 0", fontSize: 12, color: "#6B7280" },
  termsRow: { display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 16, cursor: "pointer" },
  termsLabel: { fontSize: 11, color: "#9CA3AF", lineHeight: 1.5 },
  error: { color: "#DC2626", fontSize: 12, marginBottom: 10, textAlign: "center" },
  button: { flex: 1, padding: 13, background: "#0D1B3E", color: "#fff", border: "none", borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: "pointer" },
  backBtn: { padding: "13px 18px", background: "#F7F7F9", color: "#0D1B3E", border: "none", borderRadius: 12, fontSize: 13, fontWeight: 600, cursor: "pointer" },
  footerText: { textAlign: "center", fontSize: 13, color: "#9CA3AF", marginTop: 16 },
  footerLink: { color: "#0D1B3E", fontWeight: 600, cursor: "pointer" },
};